<template>
	<div class="wp">
        <div class="w-1200 post-sale-wp">
            <div class="title-more">
                <i class="el-icon-s-home" style="color:#615E61;position:relative;top:16px;left:10px;"> </i>
                <el-breadcrumb style="width:90%;padding-left:40px;"  separator=" - ">
                        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/safeguard' }">保障中心</el-breadcrumb-item>
                        <el-breadcrumb-item>内容详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="content">
                <div class="msg-box">
                	<!-- <img src="../../assets/image/postsale/001.png"> -->
					<div class="img">
						<el-image style="width: 100%; height: 100%" :src="saleDetail.sctp" fit="contain">
							<div slot="error" v-if="type==16"   class="image-slot" style="width:100%;height:100%;">
								<img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/pingjia.jpg">
							</div>
						</el-image>
					</div>
                	<div class="msg-list">
                		<div class="t">{{saleDetail.cpmc}}</div>
                		<ul>
                			<li><div class="name">品牌</div><div>{{saleDetail.pp}}</div></li>
                			<li><div class="name">型号</div><div>{{saleDetail.xh}}</div></li>
                			<li><div class="name">产地</div><div>{{saleDetail.xh}}</div></li>
                			<li><div class="name">产品注册号</div><div>{{saleDetail.xh}}</div></li>
                			<li><div class="name">用途</div><div>{{saleDetail.yt}}</div></li>
                			<!-- <li><div class="name">招商状态</div><div>{{detail.xh}}</div></li>
                			<li><div class="name">招商区域</div><div>{{detail.xh}}</div></li> -->
                			<li><div class="name">浏览量</div><div>{{saleDetail.scanNum}}</div></li>
                		</ul>
                	</div>
                </div>
                <div class="tab-list clearfix">
                	<span v-for="(item, index) in tab.list" :key="index"
                		class="pull-left"
                		:class="{active: index == tab.idx}"
                		@click="setTabIdx(index)">
                		{{item.name}}
                		<i class="el-icon-caret-bottom"></i>
                	</span>
                </div>
                <div v-if="type==15" class="tab-content">
                	<com-richtext :richtext="saleDetail.wxal"></com-richtext>
                </div>
				<div v-if="type==16" class="tab-content">
					<com-leave-word v-if="chatId" :chatId="chatId" :source="source"></com-leave-word>
				</div>
            </div>
        </div>
    </div>
</template>
<script>
	
import PostSale from './PostSale.js';
export default PostSale;	
</script>
<style lang="scss" scoped>
@import './PostSale.scss';	
</style>
